import { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  gradient?: boolean;
}

export const InstitucionalIcon = (props: IconProps) => (
  <svg
    {...props}
    width="14"
    height="20"
    viewBox="0 0 14 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0830078 17.3096C0.0830078 17.8721 0.232422 18.3174 0.53125 18.6455C0.830078 18.9736 1.24316 19.1377 1.77051 19.1377H12.2119C12.7451 19.1377 13.1611 18.9736 13.46 18.6455C13.7588 18.3174 13.9082 17.8721 13.9082 17.3096V2.0166C13.9082 1.44824 13.7588 1.00293 13.46 0.680664C13.1611 0.352539 12.7451 0.188477 12.2119 0.188477H1.77051C1.24316 0.188477 0.830078 0.352539 0.53125 0.680664C0.232422 1.00293 0.0830078 1.44824 0.0830078 2.0166V17.3096ZM3.87988 17.5732V14.8047C3.87988 14.5996 3.94141 14.4355 4.06445 14.3125C4.19336 14.1895 4.36035 14.1279 4.56543 14.1279H9.45215C9.68066 14.1279 9.85645 14.1895 9.97949 14.3125C10.1084 14.4355 10.1729 14.5996 10.1729 14.8047V17.5732H3.87988ZM3.64258 5.04004V3.35254C3.64258 3.10645 3.75977 2.9834 3.99414 2.9834H5.76953C6.01562 2.9834 6.13867 3.10645 6.13867 3.35254V5.04004C6.13867 5.28613 6.01562 5.40918 5.76953 5.40918H3.99414C3.75977 5.40918 3.64258 5.28613 3.64258 5.04004ZM7.91406 5.04004V3.35254C7.91406 3.10645 8.03418 2.9834 8.27441 2.9834H10.041C10.2871 2.9834 10.4102 3.10645 10.4102 3.35254V5.04004C10.4102 5.28613 10.2871 5.40918 10.041 5.40918H8.27441C8.03418 5.40918 7.91406 5.28613 7.91406 5.04004ZM3.64258 8.62598V6.94727C3.64258 6.69531 3.75977 6.56934 3.99414 6.56934H5.76953C6.01562 6.56934 6.13867 6.69531 6.13867 6.94727V8.62598C6.13867 8.87793 6.01562 9.00391 5.76953 9.00391H3.99414C3.75977 9.00391 3.64258 8.87793 3.64258 8.62598ZM7.91406 8.62598V6.94727C7.91406 6.69531 8.03418 6.56934 8.27441 6.56934H10.041C10.2871 6.56934 10.4102 6.69531 10.4102 6.94727V8.62598C10.4102 8.87793 10.2871 9.00391 10.041 9.00391H8.27441C8.03418 9.00391 7.91406 8.87793 7.91406 8.62598ZM3.64258 12.2207V10.5332C3.64258 10.2812 3.75977 10.1553 3.99414 10.1553H5.76953C6.01562 10.1553 6.13867 10.2812 6.13867 10.5332V12.2207C6.13867 12.4668 6.01562 12.5898 5.76953 12.5898H3.99414C3.75977 12.5898 3.64258 12.4668 3.64258 12.2207ZM7.91406 12.2207V10.5332C7.91406 10.2812 8.03418 10.1553 8.27441 10.1553H10.041C10.2871 10.1553 10.4102 10.2812 10.4102 10.5332V12.2207C10.4102 12.4668 10.2871 12.5898 10.041 12.5898H8.27441C8.03418 12.5898 7.91406 12.4668 7.91406 12.2207Z"
      fill={props.gradient ? "url(#paint0_linear_159_1069)" : "#746D7D"}
    />
    {props.gradient && (
      <defs>
        <linearGradient
          id="paint0_linear_159_1069"
          x1="-7.89109"
          y1="-5"
          x2="26.1628"
          y2="0.975647"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EA336B" />
          <stop offset="1" stopColor="#6911E7" />
        </linearGradient>
      </defs>
    )}
  </svg>
);
